// extracted by mini-css-extract-plugin
export var content = "DownloadsImagesItem-module--content--OZexx";
export var contentImage = "DownloadsImagesItem-module--content-image--Bliyj";
export var contentImageInner = "DownloadsImagesItem-module--content-image-inner--u+xAG";
export var contentImageRibbon = "DownloadsImagesItem-module--content-image-ribbon--iy5UL";
export var contentLinks = "DownloadsImagesItem-module--content-links--nhBsc";
export var contentSubTitle = "DownloadsImagesItem-module--content-sub-title--mH3DQ";
export var contentTitle = "DownloadsImagesItem-module--content-title--X8e-a";